import {h} from 'ui/Framework';

export default h('svg', {
  width: '50',
  height: '22',
  viewBox: '-1 -1 52 24',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', {
      fill: '#21304A'
    }, [
      h('g', [
        h('path', {
          d: 'M2.162 21.223H0L8.374 1.847h1.916l8.32 19.376h-2.19l-2.134-5.09H4.269l-2.107 5.09zm2.846-6.896h8.539l-4.27-10.29-4.269 10.29zm18.254 4.734v2.162h-1.86V.533h1.86v10.1h.055a5.289 5.289 0 0 1 2.135-1.903 6.093 6.093 0 0 1 2.709-.643c1.003 0 1.911.173 2.723.52a6.204 6.204 0 0 1 2.08 1.423 6.427 6.427 0 0 1 1.34 2.135 7.26 7.26 0 0 1 .48 2.654 7.26 7.26 0 0 1-.48 2.655 6.427 6.427 0 0 1-1.34 2.135 6.204 6.204 0 0 1-2.08 1.423c-.812.346-1.72.52-2.723.52-.93 0-1.834-.21-2.71-.63a5.254 5.254 0 0 1-2.134-1.86h-.055zm9.551-4.242a6.08 6.08 0 0 0-.328-2.011 4.869 4.869 0 0 0-.944-1.642 4.452 4.452 0 0 0-1.52-1.108c-.601-.274-1.285-.411-2.052-.411-.711 0-1.368.132-1.97.397a4.73 4.73 0 0 0-1.56 1.095 5.055 5.055 0 0 0-1.026 1.642c-.247.629-.37 1.309-.37 2.038 0 .73.123 1.41.37 2.04.246.629.588 1.172 1.026 1.628a4.83 4.83 0 0 0 3.53 1.477c.767 0 1.45-.132 2.053-.396a4.302 4.302 0 0 0 1.519-1.095c.41-.465.725-1.013.944-1.642.219-.63.328-1.3.328-2.012zm15.19-3.475c-.311-.493-.763-.899-1.355-1.218a4.006 4.006 0 0 0-1.93-.479c-.748 0-1.423.132-2.025.397a4.582 4.582 0 0 0-1.546 1.095 4.811 4.811 0 0 0-.986 1.642 5.941 5.941 0 0 0-.342 2.038c0 .73.114 1.405.342 2.026.229.62.552 1.163.972 1.628.42.465.93.83 1.533 1.095.602.264 1.277.396 2.025.396.82 0 1.514-.155 2.08-.465a4.257 4.257 0 0 0 1.395-1.204l1.396 1.04a6.102 6.102 0 0 1-2.011 1.615c-.794.401-1.747.602-2.86.602-1.04 0-1.98-.169-2.82-.507a6.241 6.241 0 0 1-2.147-1.409 6.383 6.383 0 0 1-1.382-2.135 7.156 7.156 0 0 1-.493-2.682c0-.967.164-1.86.493-2.682a6.383 6.383 0 0 1 1.382-2.134 6.241 6.241 0 0 1 2.148-1.41c.84-.337 1.779-.506 2.819-.506.857 0 1.728.187 2.613.561a5.117 5.117 0 0 1 2.149 1.656l-1.45 1.04z'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-shorttext.es6.js